<template>
  <v-card outlined tile>
    <v-row class="mt-1">
      <v-col>
        <div class="float-right mr-5">
          <v-tooltip v-if="user_info.isMap" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'ConsumerMap',
                  params: {
                    device_group_id: groupId,
                  },
                }"
                color="primary"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                depressed
                ><v-icon>mdi-google-maps</v-icon></v-btn
              >
            </template>
            <span>{{ $t('consumerMap') }}</span>
          </v-tooltip>
          <v-tooltip v-if="user_info.isMap" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'DashboardAdmin',
                  params: {
                    device_group_id: currentGroupId,
                  },
                }"
                color="primary"
                class="mr-2"
                dark
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon>mdi-monitor-dashboard</v-icon></v-btn
              >
            </template>
            <span>{{ $t('dashboard') }}</span>
          </v-tooltip>
          <v-tooltip top v-if="isAlarmEmailExtractEnabled">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" @click="mailCsvDownload" class="mr-2" v-bind="attrs" v-on="on" depressed
                ><v-icon>mdi-download</v-icon><v-icon>mdi-email</v-icon></v-btn
              >
            </template>
            <span>{{ $t('alarmEmailConfigurationExtraction') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" @click="openPage" class="mr-2" v-bind="attrs" v-on="on" depressed
                ><v-icon>mdi-email</v-icon></v-btn
              >
            </template>
            <span>{{ $t('alarmNotificationEmailSettings') }}</span>
          </v-tooltip>
          <v-btn color="primary" dark @click="csvClicked" class="mr-2" depressed>
            <v-icon>mdi-download</v-icon>CSV</v-btn
          >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickAddInfoDetail" color="primary" dark v-bind="attrs" v-on="on" class="mr-2" depressed>
                <v-icon>mdi-magnify-plus</v-icon></v-btn
              >
            </template>
            <span>{{ $t('getOperatingStatus') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'AlermHistory',
                  params: {
                    device_group_id: groupId,
                  },
                }"
                color="primary"
                class="mr-2"
                dark
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon>mdi-alert-circle</v-icon></v-btn
              >
            </template>
            <span>{{ $t('alarmRecords') }}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-data-table
        fixed-header
        :headers="headers"
        :items="items"
        item-key="device_group_id"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        @click:row="clickRow"
        class="v-data-table-outlined border-bottom-none"
      >
        <template v-slot:top>
          <v-card flat tile class="pa-3 v-card-border-bottom">
            <v-form v-model="valid" ref="form" @submit.prevent>
              <v-row class="d-flex align-center">
                <v-col
                  ><v-text-field
                    v-model="searchWord.optionalInfo"
                    :label="$t(`company`)"
                    hide-details
                    outlined
                    dense
                  ></v-text-field
                ></v-col>
                <v-col>
                  <v-card-actions class="float-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="reset" color="primary" dark v-bind="attrs" v-on="on" class="mr-2" depressed>
                          <v-icon>mdi-close</v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t('deleteSearchConditions') }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="searchClicked" color="primary" dark v-bind="attrs" v-on="on" depressed>
                          <v-icon>mdi-magnify </v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t('search') }}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-row class="px-2">
            <v-col cols="6" sm="6" md="6" ls="6" xl="6">
              {{ $t(`display`) }}
              <div class="d-inline-block">
                <v-select
                  :value="selectedItemsPerPage"
                  :items="[
                    { text: '10', value: 10 },
                    { text: '20', value: 20 },
                    { text: $t(`all`), value: -1 },
                  ]"
                  item-text="text"
                  item-value="value"
                  @change="itemsPerPage = parseInt($event, 10)"
                />
              </div>
            </v-col>
            <v-col cols="6" sm="6" md="6" ls="6" xl="6" v-if="pageCount > 1">
              <div class="float-right">
                <v-btn
                  @click="changePage(1)"
                  :color="page !== 1 ? 'primary' : ''"
                  :dark="page !== 1"
                  small
                  :disabled="page === 1"
                  class="mr-3"
                  ><v-icon>mdi-page-first</v-icon>1</v-btn
                >
                <v-btn
                  @click="prevPage"
                  :color="page !== 1 ? 'primary' : ''"
                  :dark="page !== 1"
                  small
                  :disabled="page === 1"
                  class="mr-3"
                  ><v-icon>mdi-chevron-left</v-icon></v-btn
                >
                {{ page }}
                <v-btn
                  @click="nextPage"
                  :color="page !== pageCount ? 'primary' : ''"
                  :dark="page !== pageCount"
                  small
                  :disabled="page === pageCount"
                  class="ml-3"
                  ><v-icon>mdi-chevron-right</v-icon></v-btn
                >
                <v-btn
                  @click="changePage(pageCount)"
                  :color="page !== pageCount ? 'primary' : ''"
                  :dark="page !== pageCount"
                  small
                  :disabled="page === pageCount"
                  class="ml-3"
                  >{{ pageCount }}<v-icon>mdi-home</v-icon></v-btn
                >
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.device_group_name_locale`]="{ item }">
          <span class="text-subtitle-1">{{ item[`device_group_name_locale${localeId}`] }}</span>
        </template>
        <template v-slot:[`item.additional.devicesCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.devicesCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.alermCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.alermCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.drivingCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.drivingCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.notDrivingCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.notDrivingCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.connectionOffCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.connectionOffCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.communicatedCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.communicatedCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.notCommunicatedCount`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.notCommunicatedCount | numberFormat }}</span>
        </template>
        <template v-slot:[`item.additional.notReceivedTheConsentForm`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.notReceivedTheConsentForm | numberFormat }}</span>
        </template>

        <template v-slot:[`header.device_group_name_locale`]="{ header }"> {{ header.text }}<br /> </template>
        <template v-slot:[`header.additional.devicesCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.devicesCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.alermCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.alermCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.drivingCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.drivingCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.notDrivingCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.notDrivingCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.connectionOffCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.connectionOffCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.communicatedCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.communicatedCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.notCommunicatedCount`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.notCommunicatedCount | numberFormat }})</span>
        </template>
        <template v-slot:[`header.additional.notReceivedTheConsentForm`]="{ header }">
          {{ header.text }}<br /><span>({{ sum.notReceivedTheConsentForm | numberFormat }})</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  import csv from '@/utils/csv';

  import { mapGetters } from 'vuex';
  import { homeAdminTab1Mixin } from '@/utils/dashbord.js';

  export default {
    name: 'Table',
    components: {},
    mixins: [csv, homeAdminTab1Mixin()],
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: -1,
      selectedItemsPerPage: undefined, // selectの選択保持用
      valid: true,
      searchWord: {
        optionalInfo: '',
      },
      internalSearchWord: {
        optionalInfo: '',
      },
      isAlarmEmailExtractEnabled: false,
      currentGroupId: undefined,
    }),
    props: {
      value: null,
    },
    filters: {
      numberFormat: (value) => {
        if (isNaN(value) || value === undefined) {
          return '';
        }
        let formatter = new Intl.NumberFormat('ja-JP');
        return formatter.format(value);
      },
    },
    watch: {
      groupId() {
        document.getElementsByClassName('v-data-table__wrapper')[0].scroll(0, 0);
        window.scroll(0, 0);
        this.reset();
        this.currentGroupId = this.groupId;
      },
      async groupAuthritesInit(newValue) {
        // storeの初期化が完了すればデバイスを取得する
        if (newValue) {
          this.$store.commit('loading/start_loading');
          try {
            await this.getGroup();
          } finally {
            this.$store.commit('loading/end_loading');
          }
        }
      },
    },
    computed: {
      ...mapGetters('auth', ['user_info']),
      headers() {
        return [
          {
            text: this.$t('company'),
            align: 'start',
            value: 'device_group_name_locale',
            filterable: true,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`numberOfMachines`),
            align: 'end',
            value: 'additional.devicesCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`alarming`),
            align: 'end',
            value: 'additional.alermCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`running`),
            align: 'end',
            value: 'additional.drivingCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`stop`),
            align: 'end',
            value: 'additional.notDrivingCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`disconnected`),
            align: 'end',
            value: 'additional.connectionOffCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`communicated`),
            align: 'end',
            value: 'additional.communicatedCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`notCommunicated`),
            align: 'end',
            value: 'additional.notCommunicatedCount',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t(`notReceivedTheConsentForm`),
            align: 'end',
            value: 'additional.notReceivedTheConsentForm',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
        ];
      },

      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
    },
    async created() {
      this.currentGroupId = this.groupId;
      this.selectedItemsPerPage = { text: this.$t('all'), value: -1 };
      this.$store.commit('loading/start_loading');
      // storeが初期化済みであればここでトリガー
      if (this.groupAuthritesInit) {
        this.$store.commit('loading/start_loading');
        try {
          await this.getGroup();
        } finally {
          this.$store.commit('loading/end_loading');
        }
      }
      if (this.user_info.userId !== 'Q118800Admin@user.kobelink.com') {
        this.isAlarmEmailExtractEnabled = false;
      } else {
        this.isAlarmEmailExtractEnabled = true;
      }
    },
    methods: {
      async reset() {
        this.$refs.form.reset(); //internalSearchWordの各項目はnullが入る
        this.internalSearchWord.optionalInfo = undefined;
        this.$store.commit('loading/start_loading');
        try {
          await this.getGroup();
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async searchClicked() {
        console.log('サーチ');
        this.$store.commit('loading/start_loading');
        try {
          // // INPUT項目の値を直接参照するとcustom-filterの監視対象に入ってしまう(検索ボタンを押さずに絞り込みされてしまう)ため別オブジェクトに格納
          this.internalSearchWord.optionalInfo = this.searchWord.optionalInfo;

          if (this.internalSearchWord.optionalInfo) {
            await this.searchGroup();
          }
        } finally {
          console.info('検索完了');
          this.$store.commit('loading/end_loading');
        }
      },
      async searchGroup() {
        console.info('検索開始');
        try {
          const optionalInfo = this.internalSearchWord.optionalInfo;

          // 検索ワードが設定されている場合
          // 検索で絞り込むためのコールバック
          const callback = async (group) => {
            if (
              group[`device_group_name_locale${this.localeId}`] &&
              group[`device_group_name_locale${this.localeId}`].indexOf(optionalInfo) >= 0
            ) {
              console.log(`対象あり groupWarker: ${group.device_group_id}`);
              return [group];
            }
            return [];
          };
          const searchResult = await this.$store.getters['groupAuthorities/searchGroup'](this.groupId, callback);
          this.items = searchResult.map((el) => {
            el.additional = {};
            return el;
          });
          await this.addInfo();
        } catch (error) {
          console.error(error);
        } finally {
          console.info('検索完了');
        }
      },
      changePage(value) {
        // ページング処理、先頭ページ、最終ページへのジャンプ用
        this.page = value;
      },
      prevPage() {
        if (this.page !== 1) {
          this.page--;
        }
      },
      nextPage() {
        if (this.page !== this.pageCount) {
          this.page++;
        }
      },
      clickRow(item) {
        if (item.children === undefined || item.children.length !== 0) {
          this.currentGroupId = item.device_group_id;
          this.$emit('update_child', item);
        } else {
          // 葉ノードの場合は、需要家になるので需要家トップへ画面遷移
          this.$router.push({
            name: 'HomeConsumer',
            params: {
              device_group_id: item.device_group_id,
            },
          });
        }
      },
      csvClicked() {
        console.log('CSVダウンロード');

        // 需要家の場合は住所と同意書の項目が増える
        let items = [];
        const header = [
          this.$t('company'),
          this.$t('numberOfMachines'),
          this.$t('alarming'),
          this.$t('running'),
          this.$t('stop'),
          this.$t('disconnected'),
          this.$t('communicated'),
          this.$t('notCommunicated'),
          this.$t('notReceivedTheConsentForm'),
        ];

        items.push(header);

        this.items.forEach((el) => {
          let lineData = [];
          lineData.push(el[`device_group_name_locale${this.localeId}`]);
          lineData.push(el.additional.devicesCount);
          lineData.push(el.additional.alermCount);
          lineData.push(el.additional.drivingCount);
          lineData.push(el.additional.notDrivingCount);
          lineData.push(el.additional.connectionOffCount);
          lineData.push(el.additional.communicatedCount);
          lineData.push(el.additional.notCommunicatedCount);
          lineData.push(el.additional.notReceivedTheConsentForm);
          items.push(lineData);
        });

        const fileName = `${this.$dayjs().format('YYYYMMDD')}.csv`;
        this.downloadCsv(fileName, items);
      },
      async mailCsvDownload() {
        this.$store.commit('loading/start_loading');
        try {
          let alertMailItemsAllFlag = [];
          let itemsAllFlag = [];
          let alertMailItemsMachineFlag = [];
          let itemsMachineFlag = [];
          // source_flagが「1」のアラーム通知用メールアドレスデータの取得
          const alertMailDestinationListsMachineFlag = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists',
            'GET',
            {
              source_flag: 1,
            }
          );

          // 配列型で入っているデータを分解
          if (Array.isArray(alertMailDestinationListsMachineFlag)) {
            alertMailItemsMachineFlag = [...alertMailDestinationListsMachineFlag];
          } else {
            alertMailItemsMachineFlag = [alertMailDestinationListsMachineFlag];
          }
          // CSV出力用データに変換
          itemsMachineFlag = Object.values(alertMailItemsMachineFlag).map((item) => [
            item.id,
            item.source_flag,
            item.source_type,
            item.user_name,
            item.mail,
            item.locale,
            item.severity,
            item.version,
            item.inserted,
            item.insert_time,
            item.updated,
            item.update_time,
          ]);
          //ヘッダー行の追加
          itemsMachineFlag.unshift([
            'id',
            'source_flag',
            'source_type',
            'user_name',
            'mail',
            'locale',
            'severity',
            'version',
            'inserted',
            'insert_time',
            'updated',
            'update_time',
          ]);
          this.downloadCsv(`machine-alarmmail_${this.$dayjs().format('YYYYMMDD')}.csv`, itemsMachineFlag);

          // -------------------------------------------------------------------------
          // source_flagが「0」のアラーム通知用メールアドレスデータの取得
          const alertmailDestinationListsAllFlag = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists',
            'GET',
            {
              source_flag: 0,
            }
          );

          // 配列型で入っているデータを分解
          if (Array.isArray(alertmailDestinationListsAllFlag)) {
            alertMailItemsAllFlag = [...alertmailDestinationListsAllFlag];
          } else {
            alertMailItemsAllFlag = [alertmailDestinationListsAllFlag];
          }
          // CSV出力用データに変換
          let deviceGroup = {}; // キャッシュ用オブジェクト
          this.previousSourceType = null;

          //source_typeで重複の削除
          const uniqueItems = [
            ...new Map([...alertMailItemsAllFlag].reverse().map((item) => [item.source_type, item])).values(),
          ];
          //重複の削除されたデータで設備名を検索
          await Promise.all(
            Object.values(uniqueItems).map(async (item) => {
              if (!item.source_type) {
                return [];
              } else {
                deviceGroup = await this.deviceGroupSearch(item.source_type);
              }
              item.equipmentName = deviceGroup;
              uniqueItems.push(Object.values(item));
            })
          );
          const uniqueItemsMap = new Map(uniqueItems.map((item) => [item.source_type, item.equipmentName]));
          itemsAllFlag = alertMailItemsAllFlag.map((item) => [
            item.id,
            item.source_flag,
            item.source_type,
            item.user_name,
            item.mail,
            item.locale,
            item.severity,
            item.version,
            item.inserted,
            item.insert_time,
            item.updated,
            item.update_time,
            uniqueItemsMap.get(item.source_type) || '',
          ]);
          // ヘッダー行を追加
          itemsAllFlag.unshift([
            'id',
            'source_flag',
            'source_type',
            'user_name',
            'mail',
            'locale',
            'severity',
            'version',
            'inserted',
            'insert_time',
            'updated',
            'update_time',
            '設備名',
          ]);
          this.downloadCsv(`device-group-alarmmail_${this.$dayjs().format('YYYYMMDD')}.csv`, itemsAllFlag);
          this.$store.commit('loading/end_loading');
        } catch (error) {
          console.error(error);
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async deviceGroupSearch(sourceType) {
        try {
          const response = await this.apiRequest('/v1/master-info/deviceGroups', 'GET', {
            device_group_id: sourceType,
          });
          if (response && response[0] && response[0].name_locale1) {
            return response[0].name_locale1;
          } else {
            throw new Error('設備名が取得できませんでした。');
          }
        } catch (error) {
          console.error(error);
          return '';
        }
      },
    },
  };
</script>
<style scoped></style>
